import { InLine } from '@lib/iab/iab-vast-model';

import createCategory from './category';
import createSurvey from './survey';
import inheritAd from '../inherit/ad';

interface UnmarshalerNode {
    _value: unknown;
    [key: string]: unknown;
}

interface ParseOptions {
    errorHandler: {
        tryRecover: (error: Error) => void;
    };
}

const createInLine = ($ad: UnmarshalerNode, options: ParseOptions): InLine => {
    const inLine = new InLine();
    const $inLine = $ad.inLine as UnmarshalerNode;
    inheritAd($ad, $inLine, inLine, options);

    inLine.adTitle =
        $inLine.adTitle != null
            ? (($inLine.adTitle as UnmarshalerNode)._value as string)
            : null;

    if ($inLine.category != null) {
        inLine.categories.push(
            ...($inLine.category as UnmarshalerNode[])
                .filter((c) => (c as UnmarshalerNode).authority != null) // Ignores declarations such as <Category/>.
                .map((category: UnmarshalerNode) =>
                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    createCategory(category as any)
                )
        );
    }

    inLine.description =
        $inLine.description != null
            ? (($inLine.description as UnmarshalerNode)._value as string)
            : null;
    inLine.advertiser =
        $inLine.advertiser != null
            ? (($inLine.advertiser as UnmarshalerNode)._value as string)
            : null;

    if ($inLine.survey != null) {
        inLine.surveys.push(
            ...($inLine.survey as UnmarshalerNode[])
                .filter(
                    (s) => ((s as UnmarshalerNode)._value as string).length > 0
                )
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                .map((survey: UnmarshalerNode) => createSurvey(survey as any))
        );
    }

    return inLine;
};

export default createInLine;
